module.exports = __webpack_public_path__ + "media/images/icon-resource-video-0942d077a7c31af885111c04ec03fd41.png";